// @noflow

import { captureMessage } from '@/utils/sentry'

type AnalyticsBackend = ((event: string, properties: {}, integrations?: {}) => void)
export type InteractionEventProperties = {
  context: string,
  object: string,
  action: string
}

export default function segmentTrack (
  eventName: string,
  properties: {} = {},
  integrations?: {} = {}): void {
  try {
    const params = [eventName, properties]
    if (Object.keys(integrations).length > 0) params.push({ integrations })

    window.analytics.track(...params)

    if (!window.analytics.user().id())
      captureMessage('No userId for segment track', { extra: { eventName } })
  } catch (error) {
    console.error(error)
  }
}

export class Analytics {
  static track (
    event: string,
    properties: {} = {},
    integrations: {} = {},
    analyticsBackend: AnalyticsBackend = segmentTrack): void {
    try {
      analyticsBackend(event, properties, integrations)
    } catch (error) {
      console.error(error)
    }
  }

  static trackInteraction (
    event: string,
    interactionEventProperties: InteractionEventProperties,
    extraProperties: {||} = {},
    analyticsBackend: AnalyticsBackend = segmentTrack): void {
    const properties = {
      ...interactionEventProperties,
      ...extraProperties
    }
    try {
      analyticsBackend(event, properties)
    } catch (error) {
      console.error(error)
    }
  }
}
